export const skills = [
  {
    name: "React",
    image: require('../images/skills/reactjs.png'),
    url: "https://react.dev/learn"
  },
  {
    name: "Next.js",
    image: require('../images/skills/nextjs.png'),
    url: "https://nextjs.org/"
  },
  {
    name: "TypeScript",
    image: require('../images/skills/typescript.png'),
    url: "https://www.typescriptlang.org/"
  },
  {
    name: "JavaScript",
    image: require('../images/skills/javascript.png'),
    url: "https://www.javascript.com/"
  },
  {
    name: "NodeJS",
    image: require('../images/skills/nodejs.png'),
    url: "https://nodejs.org/en"
  },
  {
    name: "Expo",
    image: require('../images/skills/expo.png'),
    url: "https://expo.dev/"
  },
  {
    name: "HTML",
    image: require('../images/skills/html.png'),
    url: "https://html.com/"
  },
  {
    name: "CSS",
    image: require('../images/skills/css.png'),
    url: "https://en.wikipedia.org/wiki/CSS"
  },
  {
    name: "WordPress",
    image: require('../images/skills/wordpress.png'),
    url: "https://wordpress.com/"
  },
  {
    name: "Squarespace",
    image: require('../images/skills/squarespace.png'),
    url: "https://www.squarespace.com/"
  },
  {
    name: "GitHub",
    image: require('../images/skills/github.png'),
    url: "https://github.com/"
  },
  {
    name: "Illustrator",
    image: require('../images/skills/illustrator.png'),
    url: "https://www.adobe.com/products/illustrator.html"
  },
  {
    name: "Photoshop",
    image: require('../images/skills/photoshop.png'),
    url: "https://www.adobe.com/products/photoshop.html"
  },
  {
    name: "InDesign",
    image: require('../images/skills/indesign.png'),
    url: "https://www.adobe.com/products/indesign.html"
  },
  {
    name: "After Effects",
    image: require('../images/skills/afterEffects.png'),
    url: "https://www.adobe.com/products/aftereffects.html"
  },
  {
    name: "Figma",
    image: require('../images/skills/figma.png'),
    url: "https://www.figma.com/blog/inside-figma/"
  },
]